import { render, staticRenderFns } from "./LandSuitabilityList.vue?vue&type=template&id=2d0360f9&scoped=true"
import script from "./LandSuitabilityList.vue?vue&type=script&lang=js"
export * from "./LandSuitabilityList.vue?vue&type=script&lang=js"
import style0 from "./LandSuitabilityList.vue?vue&type=style&index=0&id=2d0360f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0360f9",
  null
  
)

export default component.exports